import { useMemo } from 'react';
import { UserRole } from '@practium/shared';
import { useGetProperties, useGetPropertiesByBoundUsers } from '@practium/features/api';
import { toFieldDiaryFarm } from '@practium/features/field-diary';

const FARMER_BINDING_TYPE = 1;
const ROLES_WITH_BOUND_FARMERS: string[] = [UserRole.Consultant, UserRole.Company];
const PROPERTIES_LIMIT = 200;

export const useFieldDiaryFarmsClient = (userRole?: string) => {
	const hasBoundFarmers = !!userRole && ROLES_WITH_BOUND_FARMERS.includes(userRole);

	const ownProperties = useGetProperties({ limit: PROPERTIES_LIMIT });
	const boundProperties = useGetPropertiesByBoundUsers({
		bindingType: FARMER_BINDING_TYPE,
		limit: PROPERTIES_LIMIT,
		enabled: hasBoundFarmers,
	});

	const farms = useMemo(() => {
		const ownFarms = ownProperties.data.map((property) => toFieldDiaryFarm(property));
		const ownIds = new Set(ownFarms.map((farm) => farm._id));
		const boundFarms = (hasBoundFarmers ? boundProperties.data : [])
			.filter((property) => !ownIds.has(property._id))
			.map((property) => toFieldDiaryFarm(property, property.userId));
		return [...ownFarms, ...boundFarms];
	}, [ownProperties.data, boundProperties.data, hasBoundFarmers]);

	return { farms, isLoading: ownProperties.isLoading || boundProperties.isLoading };
};
